/**
 * Horário de cobertura técnica (RT on-call) — regra de negócio pura.
 *
 * Dentro do horário administrativo (08–18h, seg–sex) o RT Foscentro está de
 * plantão; fora dele, o RT JFB fica de sobreaviso (cadeia de notificação PAEBM,
 * CLAUDE.md regra #12). Consumido pelo widget de cobertura do dashboard
 * (TechCoverageCard) — por isso vive no domínio (regra #1: TS puro, sem React/DOM).
 *
 * GUPM-234: o horário é o da BARRAGEM (Patos de Minas/MG), não o da máquina.
 * `getDay()`/`getHours()` liam o fuso do host: numa VM/kiosk em UTC — comum em
 * sala de controle — o app calculava 3h adiante e apontava o contato errado da
 * cadeia (às 17h30 daqui concluía "fora do horário").
 */

/** Fuso da UPM (Patos de Minas/MG). Sem horário de verão no Brasil desde 2019. */
const FUSO_BARRAGEM = 'America/Sao_Paulo';

const FORMATADOR = new Intl.DateTimeFormat('en-US', {
  timeZone: FUSO_BARRAGEM,
  weekday: 'short',
  hour: 'numeric',
  hour12: false,
});

const DIAS_UTEIS: ReadonlySet<string> = new Set(['Mon', 'Tue', 'Wed', 'Thu', 'Fri']);

export function isBusinessHours(now: Date = new Date()): boolean {
  const partes = FORMATADOR.formatToParts(now);
  const weekday = partes.find((p) => p.type === 'weekday')?.value ?? '';
  // `hour12: false` pode devolver "24" na meia-noite em alguns runtimes — normaliza.
  const hour = Number(partes.find((p) => p.type === 'hour')?.value ?? NaN) % 24;
  return DIAS_UTEIS.has(weekday) && hour >= 8 && hour < 18;
}
